import actions from './actions';

const initState = {
    data: []
};

export default function ScenarioReducer(state = initState, action) {
    switch (action.type) {
        case actions.Scenario_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
